import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
  AfterViewInit,
  ChangeDetectorRef,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { createFieldId, describedBy, FieldErrorState } from './field-id';

@Component({
  selector: 'ngx-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
})
export class TextInputComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy, ControlValueAccessor {
  @Input() require = false;
  @Input() pattern = '';
  @Input() patternError = '';
  private delayTime: number = 300;
  private validtionDelay;
  @Input() label = '';
  @Input() fireAlert = false;
  @Input() readonly = false;
  @Input() disable = false;
  @Input() type = 'text';
  @Input() min: any;
  @Input() max: number;
  @ViewChild('child', { static: false }) field: ElementRef;
  @ViewChild('field', { static: false }) inputControl: NgModel;
  @Input() placeholder = undefined;
  /** Id of the inner <input>; pass it when an outer <label for> must point at this control. */
  @Input() inputId: string = createFieldId('uc-text-input');
  /** Optional guidance shown under the control and announced through aria-describedby. */
  @Input() helperText: string;

  @ViewChild('child', { static: false }) feild: ElementRef;
  @Output() inputValid = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) { }

  _inputValue = undefined;
  get inputValue() {
    return this._inputValue;
  }
  set inputValue(val) {
    this._inputValue = val;
    this.propagateChange(this._inputValue);

    if (val) {
      this.inputControl.control.markAsTouched();
    }

    if (this.field) {
      setTimeout(() => {
        this.inputValid.emit(this.field.nativeElement.validity.valid);
      }, 20);
    }
  }
  startCountingToShowValidation(field: NgModel) {
    if (!field.control.valid) {
      this.cancelValidation();
      this.Validate();
    }
    this.inputValid.emit(field.control.valid);
  }
  Validate() {
    this.validtionDelay = setTimeout(() => { }, this.delayTime);
  }

  cancelValidation() {
    clearTimeout(this.validtionDelay);
  }

  propagateChange = (_: any) => { };
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched() { }
  writeValue(value: any) {
    if (value !== undefined) {
      this.inputValue = value;
    }
  }
  emitValidity() {
    setTimeout(() => {
      this.inputValid.emit(this.field.nativeElement.validity.valid);
    });
  }

  get helperId(): string {
    return `${this.inputId}-helper`;
  }

  get errorId(): string {
    return `${this.inputId}-error`;
  }

  /** Settled error flag shared by aria-invalid, aria-describedby and the error message (see FieldErrorState). */
  readonly errorState = new FieldErrorState(
    () => this.cdr.markForCheck(),
    (model) => !!(model?.errors && (model.touched || this.fireAlert))
  );

  get errorShown(): boolean {
    return this.errorState.first;
  }

  get describedByIds(): string | null {
    return describedBy(this.helperText && this.helperId, this.errorShown && this.errorId);
  }

  ngOnChanges(): void {
    this.errorState.schedule();
  }

  ngAfterViewInit(): void {
    this.errorState.watch([this.inputControl]);
  }

  ngOnDestroy(): void {
    this.errorState.destroy();
  }

  ngOnInit() { }
}
